import axiosInstance from './axiosInstance';

const getConfigWebPage = ({ webPage, route }) =>
  axiosInstance.get('/internal/config/web_pages', {
    params: { web_page: webPage, route },
  });

export default getConfigWebPage;
